import * as React from 'react'
import { StyleSheet, View } from 'react-native'

type Props = {
  children: React.ReactNode
}

export function Footer({ children }: Props) {
  return <View style={styles.footer}>{children}</View>
}

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: 6,
    marginBottom: 8,
  },
})
